import { TINY, SMALL, MEDIUM, LARGE } from "shared/utils/constants";
import cx from "classnames";
import styles from "./Spacing.module.css";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  size?: "tiny" | "small" | "regular" | "medium" | "large";
};

export const Spacing = ({ children, size = "regular" }: Props) => (
  <div
    className={cx(styles.spacing, {
      [styles.tiny]: size === TINY,
      [styles.small]: size === SMALL,
      [styles.medium]: size === MEDIUM,
      [styles.large]: size === LARGE,
    })}
  >
    {children}
  </div>
);
